<template>
  <el-dialog
    :title="dataLog ? '操作日志' : '数据日志'"
    v-model="dialogVisible"
    :append-to-body="true"
    width="555px">
    <div class="header" v-if="!dataLog">
      <div :class="view ? 'active' : ''" @click="getView(true)">数据日志</div>
      <div :class="!view ? 'active' : ''" @click="getView(false)">存证日志</div>
    </div>
    <div class="table">
      <el-table
        height="250px"
        :data="tableData"
        :stripe="true"
        :header-cell-style="{ background: '#f8f9fb', color: '#333', fontWeight: 'normal' }"
        style="width: 100%">
        <el-table-column prop="oplogId" label="id" width="100px"></el-table-column>
        <el-table-column label="行为">
          <template v-slot="scope">
            <span @click="scope.row.status || !view ? viewUp(scope.row) : ''"
                  :style="{
              cursor: scope.row.status || !view ? 'pointer' : '',
               color: scope.row.status || !view ? '#4e86ff' : ''
            }">{{scope.row.description}}</span>
          </template>
        </el-table-column>
        <el-table-column label="日期">
          <template v-slot="scope">
            {{getTime(scope.row.ctime)}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新打开的 -->
    <el-dialog v-model="isView"
               :append-to-body="true"
               width="555px">
      <el-table class="table" :data="viewTableInfo">
        <el-table-column
          v-for="(list, index) in view ? viewTableTimeConfig : viewTableUpConfig"
          :key="index"
          :prop="list.prop"
          :label="list.label"
        />
      </el-table>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getapprovingoploglist } from '@/port/clientSide/transaction'
export default {
  name: "logComp",
  props: {
    isLogView: Boolean,
    approvalId: [Number, String],
    approvingId: [Number, String],
    // 导航过来的数据日志
    dataLog: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogVisible: false,
      isView: false,
      view: true,
      tableData: [],
      viewTableUpConfig: [
        {
          label: '分类',
          prop: 'classify'
        },
        {
          label: '链名',
          prop: 'groupname'
        },
        {
          label: '哈希值',
          prop: 'hashcode'
        }
      ],
      viewTableTimeConfig: [
        {
          label: '内容',
          prop: 'name'
        },
        {
          label: '修改前',
          prop: 'olddata'
        },
        {
          label: '修改后',
          prop: 'newdata'
        }
      ],
      viewTableInfo: []
    }
  },
  watch: {
    isLogView: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getInfo()
          this.dialogVisible = true;
        }
      }
    },
    dialogVisible: {
      immediate: true,
      handler (val) {
        if (!val) {
          this.$emit('update:isLogView', false)
          // 数据还原
          this.viewTableInfo = []
          this.isView = false
          this.view = true
        }
      }
    }
  },
  methods: {
    async getInfo () {
      const obj = {
        type: this.dataLog ? this.dataLog : this.view ? 1 : 2,
        curpage: 0,
        pagesize: 0,
        approvalId: this.approvalId
      }
      if (!this.dataLog) obj.approvingId = this.approvingId;
      const res = await getapprovingoploglist(obj)
      if (res.code === 0) {
        this.tableData = res.data
      }
    },
    getTime (time) {
      if (!time) return '';
      const date = new Date(time)
      const y = date.getFullYear()
      const m = (date.getMonth() + 1)
      const d = date.getDate()
      const s = date.getHours()
      const f = date.getMinutes()
      const ms = date.getSeconds()
      return y + '-' + m + '-' + d + ' ' + s + ':' + f + ':' + ms
    },
    getView (val) {
      this.view = val
      this.getInfo()
    },
    viewUp (item) {
      this.viewTableInfo = this.view ? JSON.parse(item.data) : [item]
      this.isView = true
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .el-dialog__header {
    padding: 10px 20px;
    background-color: #F3F3F3;
    text-align: center;
    min-height: 20px;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 10px;
  }
  ::v-deep .el-dialog__body {
    padding: 10px;
  }
  ::v-deep .el-table td, ::v-deep .el-table th {
    padding: 5px 0;
  }
  ::v-deep .el-table thead {
    color: #333333;
  }
  ::v-deep th {
    font-weight: normal;
  }
.header {
  padding-top: 10px;
  padding-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  div:nth-child(2) {
    margin-left: 109px;
  }
  div {
    font-size: 18px;
    color: #333333;
    cursor: pointer;
  }
  .active {
    color: #4e86ff;
    position: relative;
    &::after {
      width: 100%;
      height: 3px;
      background-color: #4e86ff;
      position: absolute;
      left: 0;
      bottom: -6px;
      content: "";
      border-radius: 3px;
    }
  }
}
.table {
  border: 1px solid #D8D8D8;
  border-radius: 14px;
  overflow: hidden;
}
</style>
